import React from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';

export default function ANavigationLink({ name, href, onClick }) {
	const onKeyDown = (event) => {
		if (event.keyCode === 13) {
			onClick();
		}
	};

	return (
		<li
			className="a-navigation-link"
			onClick={onClick}
			onKeyUp={onKeyDown}
			role="button"
		>
			{(href.includes("https://") || href.includes("http://")) ?
			<a href={href}><FormattedMessage id={name} defaultMessage="" /></a>
			:
				<NavLink
					to={href}
					href={href}
					activeClassName="active"
				>
					<FormattedMessage id={name} defaultMessage="" />
				</NavLink>
			}
		</li>
	);
}

ANavigationLink.propTypes = {
	name: PropTypes.string.isRequired,
	href: PropTypes.string.isRequired,
	onClick: PropTypes.func,
};

ANavigationLink.defaultProps = {
	onClick: undefined,
};



// WEBPACK FOOTER //
// ./src/components/atoms/_atoms.navigation-link.js